import * as ng from 'angular';
import * as _ from 'underscore';
import * as moment from 'moment';

import { FilterService, FilterServiceFactory } from '../../shared';
import { GuestTypeService, GuestType } from '../guest-type';
import { Report, ReportsService } from '.';

export class ReportController {
   filter:FilterService;
   inputs;

   brands:any[];
   campaigns:any[];
   guestTypes:GuestType[];

   static $inject = [
      'report', 'session', 'filterServiceFactory', 'GuestTypeService', 'ReportsService', 'titleService'
   ];

   constructor(
      public report:Report,
      private session,
      filterServiceFactory:FilterServiceFactory,
      guestTypeService:GuestTypeService,
      private reportsService:ReportsService,
      titleService
   ) {
      titleService.setTitle(report.title);

      let filterOpts = {
         key: 'report.' + this.report.id,
         defaults: {
            campaignId: this.session.getCampaign().id
         },
         properties: [],
         callback: function(property) {
            // no-op, reports are run explicitly
         }
      };

      for (let input of report.inputs) {
         if (input.defvalue) {
            filterOpts.defaults[input.key] = input.defvalue;
         } else {
            filterOpts.properties.push(input.key);
         }
      }

      if (this.report.id == 'device-usage' || this.report.id == 'transfer-status') {
         delete filterOpts.defaults.campaignId;
         filterOpts.defaults['orgId'] = this.session.getOrg().id;
      }

      this.filter = filterServiceFactory(filterOpts);

      if (this.report.id == 'email-summary') {
         this.filter['startDate'] = this.filter['startDate'] || moment().subtract(6, "months").format("MM/DD/YYYY hh:mm A");
      }

      this.brands = this.session.getOrg().brands;

      guestTypeService.list(this.session.getCampaign().id).then((guestTypes) => {
         this.guestTypes = guestTypes;
      });

      // auto-load device usage report
      if (this.report.id == 'device-usage') {
         this.load();
      }
   }

   reset(form:ng.IFormController) {
      this.filter.reset();
      this.inputs = null;
      form.$setPristine();
   }

   load(form:ng.IFormController = null) {
      if (form && form.$invalid) {
         return;
      }

      this.inputs = ng.copy(this.filter.inputs);
   }

   download() {
      this.reportsService.download(this.report.datasets[0].id, this.filter.inputs, 'xlsx');
   }

   get isDownloadOnly() {
      return this.report.datasets[0].type == 'download-only' || this.report.datasets[0].type == 'spreadsheet-tabs';
   }

   get brand() {
      return _.findWhere(this.brands, {id: this.filter['brandId']});
   }

   onFilterChange(field, value) {
      if (this.filter.inputs[field] == value) {
         delete this.filter.inputs[field];
      } else {
         this.filter.inputs[field] = value;
      }

      this.load();
   }

   onChange(filter:'campaignId'|'brandId') {
      if (filter == 'brandId') {
         this.filter['campaignId'] = null;
      }

      if (filter == 'campaignId' || filter == 'brandId') {
         this.filter['eventIds'] = null;
      }
   }

   get requiredInputs() {
      return _.filter(this.report.inputs, i => i.required && !i.defvalue);
   }
}

ng.module('e360')
   .controller('ReportController', ReportController);
